import { FaArrowLeft } from "react-icons/fa6";
import { Link } from "react-router";
import styled from "styled-components";

const Styled = styled(Link)`
    background: transparent;
    border: none;
    color: #fff;
    display: flex;
    font-size: 2.4rem;
    left: 3vw;
    opacity: .5;
    padding: 0;
    position: absolute;
    top: 9vh;

    &:hover {
        cursor: pointer;
        opacity: 1;
    }
`;

export default function Back(props) {
    return (
        <Styled { ...props }>
            <FaArrowLeft />
        </Styled>
    );
}
